"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var Logo = _styledComponents["default"].svg.withConfig({
  displayName: "Logo",
  componentId: "sc-1ryinnw-0"
})(["margin:13px 0;"]);

var XeLogo = function XeLogo(props) {
  return _react["default"].createElement(Logo, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    height: props.height,
    width: props.width,
    viewBox: "0 0 710 568.71",
    "aria-label": "XE.com Logo",
    role: "img"
  }, _react["default"].createElement("title", null, "XE.com Logo"), _react["default"].createElement("g", null, _react["default"].createElement("path", {
    fill: props.isBlueOnWhite ? "#0a146e" : "#FFF",
    d: "M271.72,428.88H191.87a2.9,2.9,0,0,1-2.46-1.37l-51.6-83.33L86.19,427.51a2.87,2.87,0,0,1-2.45,1.37H3.9a2.89,2.89,0,0,1-2.4-4.51L97.36,281.89,2.68,144.34a2.89,2.89,0,0,1,2.38-4.53H85.39a2.88,2.88,0,0,1,2.44,1.36l50,79.51,49.67-79a3.88,3.88,0,0,1,3.3-1.83h79.77a2.89,2.89,0,0,1,2.38,4.53L178.24,281.89l95.88,142.48A2.9,2.9,0,0,1,271.72,428.88ZM425.65,1a282.59,282.59,0,0,0-208,90.9,1.47,1.47,0,0,0,1.08,2.45h12.57a2.86,2.86,0,0,0,1.87-.71,256.49,256.49,0,0,1,168.92-63c141.47,0,256.14,113.6,256.14,253.73S543.6,538.08,402.13,538.08a256.51,256.51,0,0,1-168.92-63,2.86,2.86,0,0,0-1.87-.71H218.77a1.47,1.47,0,0,0-1.08,2.45,282.59,282.59,0,0,0,208,90.9C582.14,567.7,709,440.83,709,284.34S582.14,1,425.65,1ZM538,310.08H324.47c1.87,32.38,30.45,60.31,71.9,60.31,31.92,0,52.26-12.7,64.6-32.2a2.89,2.89,0,0,1,3.78-1.06l54,28a2.9,2.9,0,0,1,1.1,4.16C494.14,408.13,450,433.79,396,433.79h-.4c-85.55,0-144.13-62.6-144.13-149.45S310,134.9,395.55,134.9s147.17,66.91,147.17,149.44a147,147,0,0,1-1.65,22.55h0C540.79,308.39,539.74,310.08,538,310.08Zm-67.1-58.5c-4.47-18.38-26-53.3-71.91-53.3-44.1,0-66.77,27.59-72.15,53.3Z",
    transform: "translate(-1 -0.99)"
  })));
};

XeLogo.defaultProps = {
  isBlueOnWhite: false
};
var _default = XeLogo;
exports["default"] = _default;